import { StrictNullable } from '@/shared/types/app.types'

export interface ConfigurationListSidePanelEntity{
    id: number
    entityKey: string
}

export interface ConfigurationListSidePanelData{
    title: string
    entities: ConfigurationListSidePanelEntity[]
    obtainEntityList: (entity: ConfigurationListSidePanelEntity) => Promise<string[]>
}

export interface ConfigurationListSidepanelState {
    show: boolean
    selectedEntity: StrictNullable<ConfigurationListSidePanelEntity>
    values: string[]
    data: ConfigurationListSidePanelData
    promise: StrictNullable<Promise<void>>
}
export const initialConfigurationListSidepanelState =
    (): ConfigurationListSidepanelState => ({
        show: false,
        selectedEntity: null,
        values: [],
        data: {
            title: '',
            entities: [],
            obtainEntityList: async () => { return [] }
        },
        promise: null
    })
